export const environment = {
	production: true,
	build: {
		id: "39757021101",
		url: "https://github.com/LumosaSoftware/lumosa-portal/actions/runs/39757021101",
		version: "bfd847b8-production",
		env: "production"
	},
	microsoftAuth: {
		clientId: "6a0449c5-824a-41c8-a368-05eb92bd7f82",
		authority: "https://login.microsoftonline.com/a527d83e-25fa-440f-8590-87e1a866a57a"
	},
	cpo: {
		url: "https://cpo.lumosa.eu"
	},
	api: {
		url: "https://api.lumosa.eu"
	},
	mailto: {
		finance: "softwareteam@lumosa.eu",
	},
	grafana: {
		url: "https://grafana.acceptance.meshlink.nl/"
	},
}
